














import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Field } from '../types/field';

export default defineComponent({
  props: {
    field: {
      type: Object as PropType<Field>,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    fullName: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const placeholder = computed(() => props.field.label || defaultPlaceholder.value);

    const defaultPlaceholder = computed(() =>
      props.disabled ? t('waiting-for-signature') : t('write-your-signature-here')
    );

    const hasSignature = computed(() => !!props.field && !!props.field.signatureBiometric);

    const biometricSignature = computed(() => props.field.signatureBiometric);

    const handleClick = () => {
      if (!hasSignature.value && !props.disabled) {
        emit('click');
      }
    };

    return {
      placeholder,
      defaultPlaceholder,
      hasSignature,
      biometricSignature,
      handleClick,
      t,
    };
  },
});
